import {FC, SVGProps} from 'react';

export const ReceiptBannerIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			d="M83.9567 91.9941C78.8167 91.9941 74.6367 87.8141 74.6367 82.6741V48.9141H93.2867V82.6641C93.2867 87.8041 89.1067 91.9841 83.9667 91.9841L83.9567 91.9941Z"
			fill="black"
		/>
		<path
			d="M92.2884 49.9141V82.6641C92.2884 87.2541 88.5584 90.9841 83.9684 90.9841C79.3784 90.9841 75.6484 87.2541 75.6484 82.6641V49.9141H92.2984M94.2984 47.9141H73.6484V82.6641C73.6484 88.3641 78.2684 92.9841 83.9684 92.9841C89.6684 92.9841 94.2884 88.3641 94.2884 82.6641V47.9141H94.2984Z"
			fill="black"
		/>
		<path
			d="M84.4866 91.9845H15.5466C9.84656 91.9845 5.22656 87.3645 5.22656 81.6645V7.89453H6.22656L12.1566 15.1445L19.0766 8.24453L26.0066 15.1445L32.9266 8.24453L39.8566 15.1445L46.7866 8.24453L53.7066 15.1445L60.6366 8.24453L67.5766 15.1445L73.5166 7.89453H74.6366V47.9445"
			fill="none"
			strokeWidth="2"
			strokeMiterlimit="10"
			stroke="black"
		/>
		<path d="M63.9023 34.7129H15.9023V36.7129H63.9023V34.7129Z" fill="black" />
		<path d="M63.9023 43.8711H15.9023V45.8711H63.9023V43.8711Z" fill="black" />
		<path d="M63.9023 53.0391H15.9023V55.0391H63.9023V53.0391Z" fill="black" />
		<path d="M44.9023 62.1953H15.9023V64.1953H44.9023V62.1953Z" fill="black" />
	</svg>
);
